import { render, staticRenderFns } from "./sticky-banner-slide.vue?vue&type=template&id=61f04a92&scoped=true&"
import script from "./sticky-banner-slide.vue?vue&type=script&lang=js&"
export * from "./sticky-banner-slide.vue?vue&type=script&lang=js&"
import style0 from "./sticky-banner-slide.vue?vue&type=style&index=0&id=61f04a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f04a92",
  null
  
)

export default component.exports